import PageCompose from "../helpers/PageCompose";
import PageView from "../components/PageView";
import withRouteProps from '@xem/entity-client-react/components/withRouteProps';

export default PageCompose({}, [ withRouteProps ])(PageView);